import {Selection, root} from "./selection/index";

export default function(selector) {
  return typeof selector === "string"
      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
      : new Selection([selector == null ? [] : selector], root);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/selectAll.js
// module id = ../../../../d3-selection/src/selectAll.js
// module chunks = 4